import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import * as style from 'src/app/CardFeedDetails/components/CardFeedPendingEmptyState.style'
import CardFeedConnecting from 'src/assets/images/CardFeedConnecting.svg'
import { useCurrentBrand } from 'src/context/ConfigContext/useConfig'
import { useTranslate } from 'src/localization/Trns'
import { supportRequestUrl } from 'src/navigation/urls'

// Empty state for a pending (SUBMITTED) card feed: the bank hasn't activated
// the feed yet, so there are no cards to show. Mirrors the design-system empty
// states (illustration + heading + body) rather than the table's plain text.
const CardFeedPendingEmptyState: React.FC = () => {
  const translate = useTranslate()
  const { analytics } = useAnalyticsContext()
  const { EXTERNAL_SUPPORT_URL } = useCurrentBrand()
  const supportHref = EXTERNAL_SUPPORT_URL || supportRequestUrl()

  const handleContactSupportClick = (): void => {
    analytics.track('card feed details', { action: 'contact support clicked', variant: 'link' })
  }

  return (
    <div css={style.container} data-testid="card-feed-cards-pending">
      <img css={style.illustration} src={CardFeedConnecting} alt="" />
      <p css={style.heading}>{translate("We're connecting with your bank")}</p>
      <p css={style.body}>
        {translate(
          'This typically completes within a few hours of initial setup. You can safely leave this page — we’ll notify you when the feed is connected. If you have any questions or concerns, ${contactSupport}.',
          {
            contactSupport: (
              <a
                css={style.supportLink}
                href={supportHref}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleContactSupportClick}
                data-testid="card-feed-pending-contact-support"
              >
                {translate('contact support')}
              </a>
            ),
          },
        )}
      </p>
    </div>
  )
}

export default CardFeedPendingEmptyState
